import { render } from "./app-button-master-business-status.vue?vue&type=template&id=176c2454&scoped=true"
import script from "./app-button-master-business-status.vue?vue&type=script&lang=js"
export * from "./app-button-master-business-status.vue?vue&type=script&lang=js"

import "./app-button-master-business-status.vue?vue&type=style&index=0&id=176c2454&scoped=true&lang=css"

import exportComponent from "/var/www/payje-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-176c2454"]])

export default __exports__